/* eslint-disable jsx-a11y/accessible-emoji, no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated. Edit MoreActions.view to change it. More info: https://github.com/viewstools/docs/blob/master/UseViews/README.md#viewjs-is-auto-generated-and-shouldnt-be-edited
import * as fromFlow from 'Logic/ViewsFlow.js'
import ButtonIconOutline from 'DesignSystem/ButtonIconOutline/view.js'
import Content from './Content/view.js'
import No from './No/view.js'
import React from 'react'
import ThreeDots from 'DesignSystem/Svgs/ThreeDots/view.js'
import { css } from "emotion"

let styles = {}
styles.Vertical = css({label: 'Vertical',
  overflowY: "visible",
overflowX: "visible",
marginTop: 8})
styles.Vertical1 = css({label: 'Vertical1',
  alignSelf: "flex-start",
  marginRight: 'var(--marginRight)',
borderBottomLeftRadius: 'var(--borderBottomLeftRadius)',
borderBottomRightRadius: 'var(--borderBottomRightRadius)',
borderTopLeftRadius: 'var(--borderTopLeftRadius)',
borderTopRightRadius: 'var(--borderTopRightRadius)'})

export default function MoreActions({
  children,
  'data-testid': dataTestid,
  'data-view-path': dataViewPath,
  marginRight= 0,
dropdownRef,
borderBottomLeftRadius= 5,
borderBottomRightRadius= 5,
borderTopLeftRadius= 5,
borderTopRightRadius= 5,
onClick,
isShowing,
isSelected,
hasSelected,
viewPath= "/App/MyAccount/Content/Profile/Content/Individuals/MoreActions",
isHovered
}) {
    
    
    
    let flow = fromFlow.useFlow()
    
    

  return (<React.Fragment
>
<div
 data-testid="MoreActions.Vertical"
 data-view-path="/App/MyAccount/Content/Profile/Content/Individuals/MoreActions"
 className={`views-block ${styles.Vertical}`}
>
<div
 data-testid="MoreActions.Vertical:1"
 data-view-path="/App/MyAccount/Content/Profile/Content/Individuals/MoreActions"
 ref={dropdownRef}
 style={{'--marginRight': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--borderBottomLeftRadius': typeof borderBottomLeftRadius === 'number' ? `${borderBottomLeftRadius}px` : borderBottomLeftRadius,'--borderBottomRightRadius': typeof borderBottomRightRadius === 'number' ? `${borderBottomRightRadius}px` : borderBottomRightRadius,'--borderTopLeftRadius': typeof borderTopLeftRadius === 'number' ? `${borderTopLeftRadius}px` : borderTopLeftRadius,'--borderTopRightRadius': typeof borderTopRightRadius === 'number' ? `${borderTopRightRadius}px` : borderTopRightRadius}}
 className={`views-block ${styles.Vertical1}`}
>
<ButtonIconOutline
 data-testid="MoreActions.ButtonIconOutline"
 data-view-path="/App/MyAccount/Content/Profile/Content/Individuals/MoreActions"
viewPath={`${viewPath}/ButtonIconOutline`}
 onClick={onClick}
 isSelected={isShowing}
 paddingLeft={6}
 paddingRight={6}
>
{childProps => (
<ThreeDots
{...childProps}
 data-testid="MoreActions.ThreeDots"
 data-view-path="/App/MyAccount/Content/Profile/Content/Individuals/MoreActions"
viewPath={`${viewPath}/ThreeDots`}
 width={20}
 height={30}
 fill={childProps.isSelected ? "rgb(0,162,255)" : childProps.isHovered ? "rgb(0,162,255)" : "#606060"}
/>
)}
</ButtonIconOutline>
{flow.has(`${viewPath}/No`) ? 
<No
 data-testid="MoreActions.No"
 data-view-path="/App/MyAccount/Content/Profile/Content/Individuals/MoreActions"
viewPath={`${viewPath}/No`}
/>
 : null
}
{flow.has(`${viewPath}/Content`) ? 
<Content
 data-testid="MoreActions.Content"
 data-view-path="/App/MyAccount/Content/Profile/Content/Individuals/MoreActions"
viewPath={`${viewPath}/Content`}
 hasSelected={hasSelected}
/>
 : null
}
</div>
</div>
{children}
</React.Fragment>)
}